import { render, staticRenderFns } from "./ConfigInputS3File.vue?vue&type=template&id=bcf9108c&scoped=true&"
import script from "./ConfigInputS3File.vue?vue&type=script&lang=js&"
export * from "./ConfigInputS3File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf9108c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcf9108c')) {
      api.createRecord('bcf9108c', component.options)
    } else {
      api.reload('bcf9108c', component.options)
    }
    module.hot.accept("./ConfigInputS3File.vue?vue&type=template&id=bcf9108c&scoped=true&", function () {
      api.rerender('bcf9108c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/empresas/componentes/configs/inputs/ConfigInputS3File.vue"
export default component.exports